// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__w07sl","overflowing":"ReadFullNote_overflowing__1lavd"};